/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import termsPageStyles from "assets/jss/material-dashboard-pro-react/views/termsPageStyles.jsx";

class Privacy extends React.Component {
      render() {
            const { classes } = this.props;
            return (
                  <GridContainer justify="center" style={{ zIndex: 3 }}>
                        <GridItem xs={12} sm={12} md={6}>
                              <section>
                                    <div class="frame">
                                          <h3>개인정보처리방침</h3>
                                    </div>
                              </section>

                              <div className={classes.contentCenter}>
                                    <table>
                                          <tbody>
                                                <tr>
                                                      <td width="615">
                                                            <p><em><strong>&lt;</strong></em><em><strong>주식회사 캐어유&gt;('enbrain.org'이하 '엔브레인플랫폼')</strong></em>은(는) 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.</p>
                                                            <p><em><strong>&lt;</strong></em><em><strong>주식회사 캐어유&gt;('엔브레인플랫폼')</strong></em>&nbsp;은(는) 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.</p>
                                                            <p>○ 본 방침은부터&nbsp;<em><strong>2020</strong></em>년&nbsp;<em><strong>1</strong></em>월&nbsp;<em><strong>1</strong></em>일부터 시행됩니다.</p>
                                                      </td>
                                                </tr>
                                          </tbody>
                                    </table>
                                    <p>&nbsp;</p>
                                    <p><strong>개인정보처리방침</strong></p>
                                    <p><strong>&nbsp;</strong></p>
                                    <p><strong>제1조 개인정보의 처리 목적</strong></p>
                                    <p>개인정보의 처리 목적은 &lt;주식회사 캐어유&gt; (&lsquo;enbrain.org&rsquo;이하 &lsquo;엔브레인플랫폼&rsquo;)은(는) 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적 이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다.</p>
                                    <ul>
                                          <li>회원 가입 및 관리</li>
                                    </ul>
                                    <p>회원가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별<strong>&middot;</strong>인증 회원자격 유지<strong>&middot;</strong>관리 제한적 본인 확인 제 시행에 따른 본인확인, 서비스 부정이용 방지, 각종 고지<strong>&middot;</strong>통지, 고충처리, 분쟁 조정을 위한 기록 보존 등을 목적으로 개인정보를 처리합니다.</p>
                                    <ul>
                                          <li>민원 사무 처리</li>
                                    </ul>
                                    <p>민원인의 신원확인, 민원사항 확인, 사실조사를 위한 연락<strong>&middot;</strong>통지, 처리결과 통보 등을 목적으로 개인정보를 처리합니다</p>
                                    <ul>
                                          <li>재화 또는 서비스 제공</li>
                                    </ul>
                                    <p>서비스 제공, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 연령 인증, 요금 결제<strong>&middot;</strong>정산 등을 목적으로 개인정보를 처리합니다.</p>
                                    <ul>
                                          <li>마케팅 및 광고에는 활용</li>
                                    </ul>
                                    <p>이벤트 및 광고성 정보 제공 및 참여기회 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.</p>
                                    <p>&nbsp;</p>
                                    <p><strong>제2조 개인정보 파일 현황</strong></p>
                                    <ul>
                                          <li>정보주체는 언제든지 &lt;개인정보보호 종합포털&gt;이 보유하고있는 개인정보에 대하여 열람, 정정, 삭제, 처리정지 요구 등의 권리를 행사할 수 있습니다.</li>
                                          <li>제 1항에 따른 권리 행사는 &lt;종합지원포털(www.privacy.go.kr) &rarr; 민원 마당 &rarr; 개인정보의 열람 등 요구 &rarr; 개인정보파일 목록 검색 &rarr; 기관명에 &ldquo;주식회사 캐어유&rdquo; 입력 후 조회</li>
                                          <li>제 1항의 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보보호법 시행규칙 별지 11호 서식에 따른 위임장을 제출하셔야합니다.</li>
                                          <li>개인정보 열람 및 처리 정지 요구는 개인정보보호법 제 35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.</li>
                                          <li>개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</li>
                                          <li>정보주체 권리에 따른 열람의 요구, 정정삭제의 요구, 처리 정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인건지를 확인합니다.</li>
                                          <li>개인정보보호 종합지원포털(www.privacy.go.kr) &rarr; 민원 마당 &rarr; 개인정보의 열람 등 요구 &rarr; 개인정보파일 목록 검색 &rarr; 기관명에 &ldquo;주식회사 캐어유&rdquo; 입력 후 조회</li>
                                    </ul>
                                    <p>&nbsp;</p>
                                    <p><strong>제3조 개인정보의 처리 및 보유 기간</strong></p>
                                    <ul>
                                          <li><strong>&lt;</strong><strong>주식회사 캐어유&gt;('엔브레인플랫폼')</strong>은(는) 법령에 따른 개인정보 보유&middot;이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유, 이용 기간 내에서 개인정보를 처리, 보유합니다.</li>
                                          <li>각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.<br /> 1) 회원 가입 및 권리 : 회원 탈퇴시까지 다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료시까지</li>
                                          <li>관계 법령 위반에 따른 수사&middot;조사 등이 진행 중인 경우에는 해당 수사&middot;조사 종료 시까지</li>
                                          <li>서비스 이용에 따른 채권&middot;채무관계 잔존시에는 해당 수사&middot;조사 종료 시까지</li>
                                    </ul>
                                    <p>2) 개인기록서비스 :&nbsp; 회원 탈퇴시까지</p>
                                    <p>3) 민원사무처리 : 민원처리 종료 후 2년</p>
                                    <p>4) 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 시행령 제 29조에 따른 본인확인정보 보관 : 공지사항에 정보 게시가 종료 된 후 6개월</p>
                                    <p>5) 모바일 앱 서비스 : 모바일 앱 회원탈퇴시까지</p>
                                    <p>&nbsp;</p>
                                    <p><strong>제 4조 개인정보의 제3자 제공에 관한 사항</strong></p>
                                    <ul>
                                          <li>정보주체로부터 별도의 동의를 받는 경우</li>
                                          <li>법률에 특별한 규정이 있는 경우</li>
                                          <li>정보주체 또는 법정대리인이 의사표시를 할 수 없는 상태이거나, 주소불명 등으로 사전 동의를 받을 수 없는 경우로서, 명백히 정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우</li>
                                          <li>통계작성 및 학술연구 등의 목적을 위하여 필요한 경우로서, 특정 개인을 알아 볼 수 없는 형태로 개인정보를 제공하는 경우</li>
                                          <li>개인정보를 목적 외의 용도로 이용하거나, 이를 제3자에게 제공하지 아니하면 다른 법률에서 정하는 소관 업무를 수행할 수 없는 경우로서, 보호위원회의 심의의결을 거친경우</li>
                                          <li>조약, 그 밖의 국제협정의 이행을 위하여 외국정보 또는 국제기구에 제공하기 위하여 필요한 경우</li>
                                          <li>범죄의 수사와 공조의 제기 및 유지를 위하여 필요한 경우</li>
                                          <li>법원의 재판업무 수행을 위하여 필요한 경우</li>
                                          <li>형 및 감호, 보호처분의 집행을 위하여 필요한 경우</li>
                                          <li>위탁처리 수행업체</li>
                                    </ul>
                                    <p>- 수탁업체명 : 다솜엑스 (사업자등록번호 : 455-18-00205)<br /> - 주소 : 서울특별시 용산시 효창원로 37라길 13, 1층(용문동)<br /> - 보유기간 : 위탁계약 종료시까지 <br /> - 위탁업무 : 엔브레인플랫폼 개발 및 S/W 유지보수, 본인인증</p>
                                    <p><strong>제5조 개인정보처리 위탁</strong></p>
                                    <ul>
                                          <li><strong>&lt;</strong><strong>주식회사 캐어유&gt;('enbrain.org'이하 '엔브레인플랫폼')</strong>은(는) 위탁계약 체결 시 개인정보 보호법 제25조에 따라 위탁업무 수행 목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</li>
                                          <li>위탁 업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</li>
                                    </ul>
                                    <p>&nbsp;</p>
                                    <p><strong>제 6조 정보주체와 법정대리인의 권리, 의무 및 행사방법</strong></p>
                                    <p>정보주체와 법정대리인의 권리&middot;의무 및 그 행사방법 이용자는 개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.</p>
                                    <ul>
                                          <li>정보주체는 주식회사 캐어유에 대해 언제든지 개인정보 열람, 정정, 삭제, 처리 정지 요구 등의 권리를 행사할 수 있습니다.</li>
                                          <li>제 1항에 따른 권리 행사는 주식회사 캐어유에 대해 개인정보 보호법 시행령 제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 주식회사 캐어유은(는) 이에 대해 지체 없이 조치하겠습니다.</li>
                                          <li>제 1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</li>
                                          <li>개인정보 열람 및 처리 정지 요구는 개인정보보호법 제35조 제5항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.</li>
                                          <li>개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</li>
                                          <li>주식회사 캐어유은(는) 정보주체 권리에 따른 열람의 요구, 정정&middot;삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.</li>
                                    </ul>
                                    <p>&nbsp;</p>
                                    <p><strong>제7조 처리하는 개인정보의 항목</strong></p>
                                    <p><strong>&lt;</strong><strong>주식회사 캐어유&gt;('enbrain.org'이하 '엔브레인플랫폼')</strong>은(는) 다음의 개인정보 항목을 처리하고 있습니다.</p>
                                    <ul>
                                          <li>회원가입 및 관리</li>
                                          <li>필수항목 : 로그인ID(휴대전화번호 또는 이메일), 비밀번호, 이름, 성별, 생년월일, 국적</li>
                                          <li>선택항목 : 자택전화번호, 자택주소</li>
                                          <li>모바일 회원가입 및 관리</li>
                                          <li>필수항목 : 로그인ID(휴대전화번호 또는 이메일), 기관 회원일 경우 기관코드, 비밀번호, 이름, 성별, 생년월일</li>
                                          <li>선택항목 : 자택전화번호, 자택주소</li>
                                    </ul>
                                    <p><strong>제8조 개인정보의 안전성 확보 조치</strong></p>
                                    <p>주식회사 캐어유는 개인정보보호법 제 29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고있습니다.</p>
                                    <ul>
                                          <li>개인정보 취급 직원의 최소화 및 교육</li>
                                    </ul>
                                    <p>개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화하여 개인정보를 관리하는 대책을 시행하고있습니다.</p>
                                    <ul>
                                          <li>정지적인 자체 감사 실시</li>
                                    </ul>
                                    <p>개인정보 취급 관련 안정성 확보를 위해 정기적(년 1회 이상)으로 자체 검사를 실시하고 있습니다.</p>
                                    <ul>
                                          <li>내부관리계획의 수립 및 시행</li>
                                    </ul>
                                    <p>개인정보의 안정한 처리를 위하여 내부관리계획을 수립하고 시행하고있습니다.</p>
                                    <ul>
                                          <li>개인정보의 암호화</li>
                                    </ul>
                                    <p>이용자의 개인정보 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인 말이 알 수 있으며 중요한 데이터 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고있습니다.</p>
                                    <ul>
                                          <li>해킹 등에 대비한 기술적 대책</li>
                                    </ul>
                                    <p>해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기위하여 보안프로그램을 설치하고 주기적인 갱신&middot;점검을 하며 외부로부터 접근이 통제 된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.</p>
                                    <ul>
                                          <li>개인정보에 대한 접근 제한</li>
                                    </ul>
                                    <p>개인정보를 처리하는 데이터베이스 시스템에 대한 접근 권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단 시스템을 이용하여 외부로부터의 무단 접근을 통제하고있습니다.</p>
                                    <ul>
                                          <li>접속 기록의 보관 및 위변조 방지</li>
                                    </ul>
                                    <p>개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능을 사용하고있습니다.</p>
                                    <ul>
                                          <li>문서 보안을 위한 잠금 장치 사용</li>
                                    </ul>
                                    <p>개인정보가 포함 된 서류, 보조장치 매체 등을 잠금 장치가 있는 안전한 장소에 보관하고있습니다.</p>
                                    <p>&nbsp;</p>
                                    <p><strong>제9조 개인정보의 파기</strong></p>
                                    <p>&lt;주식회사 캐어유&gt;('엔브레인플랫폼')은(는) 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.</p>
                                    <ul>
                                          <li>파기절차</li>
                                    </ul>
                                    <p>이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.</p>
                                    <ul>
                                          <li>파기기한</li>
                                    </ul>
                                    <p>이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.</p>
                                    <ul>
                                          <li>파기방법</li>
                                    </ul>
                                    <p>전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.<br /> 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</p>
                                    <p>&nbsp;</p>
                                    <p><strong>제10조 개인정보 자동수집 장치의 설치, 운영 및 거부에 관한 사항</strong></p>
                                    <p>주식회사 캐어유는 이용자에게 특화된 맞춤서비스를 제공하기 위해서 이용자들의 정보를 수시로 저장하고 불러오는 &lsquo;쿠키(cookie)&rsquo;를 운용합니다. 쿠키란 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에 저장됩니다. 주식회사 캐어유는 다음과 같은 목적을 위해 쿠키를 사용합니다.</p>
                                    <ul>
                                          <li>쿠키의 사용 목적</li>
                                    </ul>
                                    <p>회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 개인 맞춤 서비스 제공 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.</p>
                                    <ul>
                                          <li>쿠키 설정 거부 방법</li>
                                    </ul>
                                    <p>쿠키설정을 거부하는 방법으로는 이용자가 사용하는 웹브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.</p>
                                    <p><strong>[</strong><strong>쿠키 설치 허용 여부를 지정하는 방법]</strong></p>
                                    <p>- Chrome의 경우 : 웹브라우저 우측의 설정메뉴 &gt; 화면 하단의 고급설정 표시 &gt; 개인정보의 콘텐츠 설정 버튼 &gt; 쿠키</p>
                                    <p>&nbsp;</p>
                                    <p><strong>제11조 개인정보 보호책임자</strong></p>
                                    <ul>
                                          <li>&lt;주식회사 캐어유&gt;(&lsquo;엔브레인플랫폼&rsquo;) 은(는) 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다</li>
                                          <li>개인정보 보호 책임자</li>
                                          <li>책임자 : 대표이사 신준영</li>
                                          <li>연락처 : Tel. 070-4400-7294, email. info@careyou.org, Fax. 0504-401-7294</li>
                                          <li>정보주체께서는 주식회사 캐어유(&lsquo;org&rsquo;이하 &lsquo;엔브레인플랫폼) 의 서비스을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 주식회사 캐어유(&lsquo;enbrain.org&rsquo;이하 &lsquo;엔브레인플랫폼) 은(는) 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.</li>
                                    </ul>
                                    <p>&nbsp;</p>
                                    <p><strong>제12조 개인정보 처리방침 변경</strong></p>
                                    <p>이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>
                                    <ul>
                                          <li>2020년 01월 01일자로 수정되어 시행되고있습니다.</li>
                                    </ul>
                                    <p>&nbsp;</p>
                                    <p><strong>제13조 정보주체의 권익 침해에 대한 구제방법</strong></p>
                                    <p>아래의 기관은 주식회사 캐어유 과는 별개의 기관으로서,&nbsp;&lt;주식회사 캐어유&gt;(&lsquo;enbrain.org'이하 '엔브레인플랫폼')의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다.</p>
                                    <ul>
                                          <li>개인정보 분쟁 조정위원회 : 1833-6972 (www.kopico.go.kr)</li>
                                          <li>개인정보 침해신고센터 : (국번없이) 118 ( privacy.kisa.or.kr)</li>
                                          <li>대검찰청 사이버수사과 : (국번없이) 1301 (spo.go.kr)</li>
                                          <li>경찰청 사이버안전국 : (국번없이) 182 (cyberbureau.police.go.kr)</li>
                                          <li>중앙행정심판위원회 : (국번없이) 110 (https://www.simpan.go.kr)</li>
                                    </ul>
                                    <p>&nbsp;</p>
                              </div >
                        </GridItem >
                  </GridContainer >
            );
      }
}

Privacy.propTypes = {
      classes: PropTypes.object.isRequired
};

export default withStyles(termsPageStyles)(Privacy);
